import React from 'react'
import { useQuery, gql } from '@apollo/client'
import EmailStatus from './emailStatus'

const GET_EMAIL_STATUS = gql`
  query EmailStatus($email: String!) {
    appEmailStatus(email: $email) {
      email
      status
    }
  }
`

const EmailStatusEmail = ({ email }) => {
  const { data } = useQuery(GET_EMAIL_STATUS, { variables: { email } })

  if (data?.appEmailStatus.email != null) {
    return (
      <EmailStatus
        emailStatus={data?.appEmailStatus}
        styleing="inline-flex align-top ml-2 h-5 w-5"
      />
    )
  }
}

export default EmailStatusEmail
